import http from "@/shared/services/http";

export const createLadingCode = (data: any) => http.post(`v1/bill-lading-codes`, data);
export const listLadingCodes = (params: any) => http.get(`v1/bill-lading-codes`, { params });
export const allLadingCodes = (params: any) => http.get(`v1/bill-lading-codes/all`, { params });
export const updateLadingCodePrintStatus = (data: any) => http.post(`v1/bill-lading-codes/update-print-status`, data);